<template>
<div>
    <v-container fluid>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Staff Stock Requests</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn rounded small class="ml-5" color="white" outlined @click="fnExcelReport('my-table-id', 'Staff Stock Requests')"><v-icon color="white">mdi-export</v-icon>Export</v-btn>                
            </v-toolbar>
            <v-card-title>
                <v-text-field v-model="search" label="Search" class="mx-4" append-icon="mdi-magnify" dense outlined></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="stockRequests" :search="search" dense class="elevation-1 mytable" id="my-table-id">
                <template v-slot:[`item.no`]="{ item }">
                    {{item.no}}
                </template>
                <template v-slot:[`item.remark`]="{ item }">
                    <span v-if="item.remark != 'N/A'">
                        <v-icon
                        v-if="item.remark"
                        @click="openDescDialog(item.remark)"
                        class="cursor-pointer"
                        color="blue"
                        >mdi-eye</v-icon
                    >
                    </span>
                    <span v-else>N/A</span>
                </template>
                <template v-slot:[`item.requestDate`]="{ item }">
                    {{ item.requestDate }}
                </template>
                <!-- Allotted Quantity with Eye Icon -->
                <template v-slot:[`item.allottedQuantity`]="{ item }">                    
                    <v-icon color="blue" class="cursor-pointer mr-2" @click="fetchAllotmentDetails(item)">
                    mdi-eye
                    </v-icon>
                    <span>{{ item.allottedQuantity }}</span>
                </template>

                <template v-slot:[`item.lastAllottedDate`]="{ item }">
                    {{ item.lastAllottedDate || 'N/A' }}
                </template>

                <template v-slot:[`item.action`]="{ item }">
                    <span v-if="!item.requestFulfilled">
                    <v-btn  color="primary" small @click="issueStock(item)">
                        <v-icon left>mdi-handshake</v-icon> Issue
                    </v-btn>
                </span>
                <span v-else>Request Is Fulfilled</span>

                </template>
            </v-data-table>

            <!-- Issue Stock Dialog -->
            <v-dialog v-model="dialog" max-width="900px">
                <v-card >
                    <v-toolbar flat dense class="toolbar">
                        <v-toolbar-title>Issue Stock</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="3">
                                <v-text-field label="Vendor" rounded v-model="selectedItem.invvendor" readonly outlined dense />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field label="Vendor Shop" rounded v-model="selectedItem.vendorShop" readonly outlined dense />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field label="Transaction Type" rounded v-model="selectedItem.transactionType" readonly outlined dense />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field label="Standard" rounded v-model="selectedItem.standard" readonly outlined dense />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field label="Item Category" rounded v-model="selectedItem.itemCategory" readonly outlined dense />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field label="Item Name" rounded v-model="selectedItem.itemName" readonly outlined dense />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field label="Size Label Type" rounded v-model="selectedItem.sizeLabelType" readonly outlined dense />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field label="Size Label" rounded v-model="selectedItem.sizeLabel" readonly outlined dense />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field label="Academic Year" rounded v-model="selectedItem.academicYear" readonly outlined dense />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field label="Staff" rounded v-model="selectedItem.requestedBy" readonly outlined dense />
                            </v-col>
                        </v-row>

                        <!-- Last Row: Issue Date, Quantity, and Remark -->
                        <v-row>
                            <v-col cols="12" sm="3">
                                <v-text-field label="From Date" rounded outlined dense type="date" v-model="issueDate"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="3">
                                <v-text-field label="Quantity" rounded v-model="quantity" type="number" outlined dense />
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-textarea label="Remark" rounded v-model="remark" outlined dense></v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red" @click="dialog = false">Cancel</v-btn>
                        <v-btn color="green" @click="submitIssueStock">Issue Stock</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
             <!-- Allotment Details Dialog -->
            <v-dialog v-model="dialog_allotement" max-width="600px">
            <v-card>
                <v-toolbar flat dense class="toolbar">
                        <v-toolbar-title>Allotment Details</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                <v-card-text>
                <v-list v-if="allotmentDetails.length">
                    <v-list-item v-for="(detail, index) in allotmentDetails" :key="index">
                    <v-list-item-content>
                        <v-list-item-title>
                        <strong>Item:</strong> {{ detail.itemName }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                        <strong>Quantity:</strong> {{ detail.quantity }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                        <strong>Unit Price:</strong> {{ detail.unitPrice }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                        <strong>Total Cost:</strong> {{ detail.totalCost }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                        <strong>Tax:</strong> {{ detail.tax }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                        <strong>Grand Total:</strong> {{ detail.grandTotal }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                        <strong>Date:</strong> {{ detail.transactionDate }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                        <strong>Status:</strong> {{ detail.lastAllotted ? "Last Allotment" : "Ongoing" }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                </v-list>
                <p v-else>No details available.</p>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog_allotement = false">Close</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
            <v-dialog v-model="remarkDialog" max-width="700">
                <v-card>
                    <v-card-title class="toolbar"
                    >Remark <v-spacer></v-spacer
                    ><v-icon color="white" @click="remarkDialog = false"
                        >mdi-close</v-icon
                    ></v-card-title
                    >
                    <v-divider></v-divider>
                    <v-card-text class="pb-0 pr-2">
                    <v-row justify="center" no-gutters>
                        <v-col cols="12" sm="12" md="12" class="pb-6 pt-3" align="center">
                        <b style="font-size: 17px"> {{ selectedRemark }} </b>
                        </v-col>
                    </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-card>
    </v-container>
</div> <!-- /. root div -->
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
        allotmentDetails:[],
        dialog_allotement: false,
        dialog: false,
        menu: false,
        selectedItem: {},
        issueDate:new Date().toISOString().slice(0, 10),
        quantity: "",
        remark: "",
        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,
        search: "",
        stockRequests: [],
        remarkDialog: false,
        selectedRemark:"",
        headers: [{
                text: "SR No",
                value: "no",
                sortable: false
            },
            {
                text: "Item Category",
                value: "itemCategory"
            },
            {
                text: "Item Name",
                value: "itemName"
            },
            {
                text: "Size Label Type",
                value: "sizeLabelType"
            },
            {
                text: "Size Label",
                value: "sizeLabel"
            },
            {
                text: "Standard",
                value: "standard"
            },
            {
                text: "Requested Quantity",
                value: "requestedQuantity"
            },
            {
                text: "Academic Year",
                value: "academicYear"
            },
            {
                text: "Request Date",
                value: "requestDate"
            },
            {
                text: "Allotted Quantity",
                value: "allottedQuantity"
            },
            {
                text: "Last Allotted Date",
                value: "lastAllottedDate"
            },
            {
                text: "Remark",
                value: "remark"
            },
            {
                text: "Action",
                value: "action",
                sortable: false
            },
        ],
    }),
    methods: {
        fnExcelReport(id, name) {
            let tab_text = `<table border='1px'>
            <tr>
            <th>Sr. No.</th>            
            <th>Item Category</th>
            <th>Item Name</th>
            <th>Size Label Type</th>
            <th>Size Label</th>           
            <th>Standard</th>
            <th>Requested Quantity</th>
            <th>Academic Year</th>
            <th>Request Date</th>
            <th>Allotted Quantity</th>
            <th>Last Allotted Date</th>
            <th>Remark</th>            
            </tr>`;

                this.stockRequests.forEach((s) => {
                    tab_text += `
            <tr>
                <td>${s.no}</td>
                <td>${s.itemCategory}</td>
                <td>${s.itemName}</td>
                <td>${s.sizeLabelType}</td>
                <td>${s.sizeLabel}</td>
                <td>${s.standard}</td>
                <td>${s.requestedQuantity}</td>
                <td>${s.academicYear}</td>
                <td>${s.requestDate}</td>
                <td>${s.allottedQuantity}</td>
                <td>${s.lastAllottedDate}</td>
                <td>${s.remark}</td>                
            </tr>`;
                });

                tab_text += '</table>';

                const blob = new Blob([tab_text], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const filename = name + '.xls';

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
        },
        openDescDialog(remark) {
            this.selectedRemark = remark;
            this.remarkDialog = true;
        },
        async fetchAllotmentDetails(item) {
            const payload = {
                stockRequestId: item.id,
            };
            axios.post("EduStore/fetchAllotmentDetails",payload)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.allotmentDetails=res.data.allotmentDetails
                        this.dialog_allotement=true
                    } else {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.dialog=false,
                    this.onLoad()
                });
        },
        async submitIssueStock() {
            if (!this.issueDate || !this.quantity) {
                alert("Please enter Issue Date and Quantity.");
                return;
            }
            if (parseInt(this.quantity) > parseInt(this.selectedItem.requestedQuantity)) {
                alert("Enter quantity less than or equal to requested quantity.");
                return;
            }
            const payload = {
                itemId: this.selectedItem.id,
                issueDate: this.issueDate,
                quantity: this.quantity,
                remark: this.remark,
            };
            axios.post("EduStore/saveIssueStock",payload)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.showSnackbar("green", "Stock Allotted Successfully...");
                    } else {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.dialog=false,
                    this.onLoad()
                });
        },
        issueStock(item) {
            this.selectedItem = {
                ...item
            }; // Copy item data
            this.dialog = true;
        },
        onLoad() {
            axios.post("EduStore/getStaffStockRequestDetails")
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.stockRequests = res.data.data
                    } else {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onLoad();
    },
    watch: {},
};
</script>

<style scoped>
  </style>
